<template>
  <v-form v-model="valid" ref="mainForm">
    <CarteIdentification :identification="identification" class="mb-6" />
    <CatalogueLive code="sexe" v-model="sasStage.sexe" :live="liveSasStage(6508)" />
  </v-form>
</template>

<script>
import StepFormWithValidation from "@/mixins/StepFormWithValidation"
import CarteIdentification from "@/components/form_parts/CarteIdentification.vue"

export default {
  components: { CarteIdentification },
  mixins: [StepFormWithValidation],
  props: {
    sas: { type: Object }
  },
  computed: {
    identification() {
      return this.sas.identification
    },
    sasStage() {
      return this.sas.sasStage
    }
  },
  methods: {
    liveSasStage(cle) {
      return { endpoint: "sas-stages", cle: cle, fileId: this.sasStage.id }
    }
  }
}
</script>

<style></style>
